﻿import {translation} from "@2d-front-monorepo/core";
import {initializeMvvmContext, MvvmButton, MvvmDataProvider, MvvmSwitch} from "@2d-front-monorepo/design-library";
import {PermitsMvvmErrorCollector} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback} from "react";
import {useNavigate} from "react-router";
import ChangeUserPassword from "../../content-blocks/UpdatePassword";
import UserData from "../../content-blocks/UserData";
import {reloadPermits} from "../../contexts/PermitsContext";
import {useGlobalContext} from "../../hooks/useGlobalContext";
import {useHttpClient} from "../../hooks/useHttpClient";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";

type UpdateUser = {
	email: string
	givenName: string
	familyName: string
	phone: string

	updatePassword: boolean
	oldPassword: string
	password: string
}

export default function Settings(): JSX.Element {
	const global = useGlobalContext();
	const permits = usePermits();
	const navigate = useNavigate();
	const user = permits.permits.holder;

	const context = initializeMvvmContext({
		initialState: () => {
			return {
				email: user.email,
				givenName: user.givenName ?? "",
				familyName: user.familyName ?? "",
				phone: user.cellPhone?.phone ?? "",
				updatePassword: false,
				oldPassword: "",
				password: ""
			}
		}
	});

	const onSubmit = useCallback(async function (data: UpdateUser): Promise<void> {
		const updatePassword = data.updatePassword;
		await useHttpClient().holder.update({
			userInfo: {
				givenName: data.givenName,
				familyName: data.familyName,
				email: data.email,
				phone: {
					countryCode: global.installation.countryId,
					phone: data.phone
				},

				oldPassword: updatePassword ? data.oldPassword : undefined,
				newPassword: updatePassword ? data.password : undefined
			}
		});

		await reloadPermits();
		navigate(PrivateRoutes.permitsHome);
	}, []);

	return (
		<MvvmDataProvider<UpdateUser> context={context} onSubmit={onSubmit}>
			<h1>{translation(PermitTranslations.settings_page__title)}</h1>
			<hr/>
			<div className="layout vertical gap">
				<PermitsMvvmErrorCollector/>

				<UserData global={global} context={context}/>

				<MvvmSwitch context={context}
				            property="updatePassword"
				            label={translation(PermitTranslations.settings_page__change_password)}/>

				{context.state.updatePassword ? <ChangeUserPassword context={context}/> : undefined}

				<div className="form__buttons">
					<MvvmButton kind="primary">{translation(PermitTranslations.save_changes)}</MvvmButton>
				</div>
			</div>
		</MvvmDataProvider>
	)
}
